



























































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import quotationsRepository from '@/services/quotationsRepository';
import notificationService from '@/services/notificationService';
import quototationsStats from '@/components/sales/QuotationsStats.vue';
import { DxDataGrid, DxEditing, DxColumn, DxRequiredRule, DxStateStoring, DxColumnChooser, DxColumnFixing, DxFilterRow, DxLookup } from 'devextreme-vue/data-grid';

import Card from '@/components/default/Card.vue';
import Datagrid from '@/components/default/Datagrid.vue';
import dxCustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';

import SalesNavigation from '@/modules/shared/navigation/SalesNavigation.vue';
import { QuotationType, MeasuringStatesClient, GenerateMeasuringStateCommand, InvoicesClient, GenerateInvoiceFromQuotationsCommand } from '@/data/web-api-client';
import InvoiceGenerateAdvanceDialog from '@/modules/invoicing/components/InvoiceGenerateAdvanceDialog.vue';
import InternalNotesLookupDialog from './dialogs/InternalNotesLookupDialog.vue';

@Component({
  components: {
    DxDataGrid,
    DxEditing,
    DxColumn,
    DxRequiredRule,
    DxStateStoring,
    DxColumnChooser,
    DxColumnFixing,
    DxFilterRow,
    DxLookup,
    Card,
    Datagrid,
    InvoiceGenerateAdvanceDialog,
    quototationsStats,
    SalesNavigation,
    InternalNotesLookupDialog,
  },
})
export default class QuotationsTable extends Vue {
  @Prop({ required: false })
  public projectId: any;

  @Prop({ required: false })
  public contactId: any;

  @Prop({ required: false })
  public standalone?: boolean;

  @Prop({ required: false, default: false })
  public expanded!: boolean;

  @Prop({ required: false, default: false })
  public disabled!: boolean;

  public showFilter: boolean = false;
  public loading: boolean = false;
  public creating: boolean = false;
  public show: boolean = false;
  public quotations: any[] = [];
  public quotationStatusses: any[] = [
    { value: 0, text: 'Klad' },
    { value: 1, text: 'Open' },
    { value: 2, text: 'Verstuurd' },
    { value: 3, text: 'Geaccepteerd' },
    { value: 4, text: 'Afgewezen' },
    { value: 5, text: 'Vervangen' },
  ];
  public showInternalNotes: boolean = false;
  public internalNoteText: string = '';

  stats: IQuotationStats | null = null;
  datasource: DataSource = new DataSource({
    store: new dxCustomStore({
      key: 'id',
      load: async (loadOptions) => {
        const result = await quotationsRepository.lookup(loadOptions, this.projectId, this.contactId);
        return {
          data: result.data.data,
          totalCount: result.data.totalCount,
        };
      },
      byKey: async (val: any) => {
        return (await quotationsRepository.getSingle(val)).data;
      },
    }),
    paginate: true,
  });

  public mounted() {
    this.SetStatusFilter();
  }

  public SetStatusFilter() {
    const value = this.$route.query.status;

    if (value) {
      const datagrid = (this.$refs.grid as any).$refs.quotationsTable.instance;
      if (datagrid) {
        setTimeout(() => {
          datagrid.columnOption('status', 'filterValue', value);
        }, 200);
      }
    }
  }

  public removeStatusFilter() {
    this.$router.push({ name: 'quotationsOverview' });
    const datagrid = (this.$refs.grid as any).$refs.quotationsTable.instance;
    if (datagrid) {
      setTimeout(() => {
        datagrid.columnOption('status', 'filterValue', undefined);
      }, 200);
    }
  }

  public toggleShow() {
    this.show = !this.show;
  }

  public openDetails(e: any) {
    if (e.row && !e.row.isEditing && e.column && e.column.type !== 'buttons' && e.column.type !== 'selection') {
      this.$router.push({ path: `/quotations/${e.row.data.id}`, query: { checkProjectOnHold: this.projectId ? 'false' : 'true' } });
    }
  }

  public toggleFilter() {
    this.showFilter = !this.showFilter;
  }

  public toolbarPreparing(e: any) {
    e.toolbarOptions.items.unshift({
      location: 'after',
      widget: 'dxButton',
      options: {
        icon: 'fas fa-filter',
        onClick: this.toggleFilter,
      },
    });
  }

  public refresh() {
    try {
      ((this.$refs.grid as Datagrid).$refs.quotationsTable as any).instance.refresh();
    } catch {
      // do nothing
    }
  }

  public deleteRow(e: any) {
    const self = this;
    e.cancel = new Promise(async (resolve, reject) => {
      try {
        await quotationsRepository.delete(e.data);
        notificationService.saved();
        self.refresh();
        resolve(true);
      } catch (err) {
        if (err?.response?.status === 403) {
          notificationService.showAxiosError(err);
          resolve(true);

          return;
        }

        notificationService.failedToSave();
        resolve(true);
      }
    });
  }

  public duplicate(e: any) {
    const self = this;
    e.cancel = new Promise(async (resolve, reject) => {
      try {
        const quotation = e.row.data as IQuotation;
        if (quotation.id !== undefined) {
          const newQuotation = (await quotationsRepository.duplicate(quotation.id)).data;
          this.$router.push({ path: `/quotations/${newQuotation.id}` });
        }

        notificationService.saved();

        resolve(false);
      } catch (err) {
        notificationService.showAxiosError(err);
        resolve(true);
      }
    });
  }

  public lookupInternalNote(e: any) {
    const quotation = e.row.data as IQuotation;
    const dialog = this.$refs.InternalNotesLookupDialog as InternalNotesLookupDialog;

    dialog.internalNotesText = quotation.internalNotes!;
    dialog.title = quotation.title;
    dialog.show = true;
  }

  public setInternalNotesTooltip(e: any) {
    e.component.getVisibleRows().forEach((row: any) => {
      const cell = row.cells.find((cell: any) => cell.column.type === 'buttons');

      if (!cell) {
        return;
      }

      const buttons = Array.from((cell as any).cellElement.children);
      const button = buttons.find((button: any) => (button.className as string).indexOf('fa-comment') >= 0);

      if (!button) {
        return;
      }

      const internalNotes = (row.data as IQuotation).internalNotes;

      if (!internalNotes || internalNotes!.replace(/(\r\n|\n|\r)/gm, '') == '') {
        return;
      }

      (button as any).title = internalNotes!.replace(/(\r\n|\n|\r)/gm, '');
    });
  }

  async createQuote() {
    try {
      this.creating = true;
      const quotation = (await quotationsRepository.create(this.projectId ? this.projectId : null)).data;
      this.$router.push({ path: `/quotations/${quotation.id}` });
    } catch (err) {
      notificationService.showAxiosError(err);
    } finally {
      this.creating = false;
    }
  }

  async generateMeasuringState() {
    const grid = this.$refs.grid as Datagrid;
    if (grid) {
      const selectedRows: IQuotation[] = (grid.$refs.quotationsTable as any).instance.getSelectedRowsData();
      const idList = selectedRows.map((o) => o.id);
      try {
        if (idList === undefined) {
          throw Error('IdList is empty');
        }
        const result = await new MeasuringStatesClient(undefined, this.$axios).generate(
          new GenerateMeasuringStateCommand({
            quotationIds: idList as string[],
          })
        );

        this.$router.push({ path: `/measuringstates/${result.replaceAll('/', '-')}` });

        notificationService.saved();
        this.$emit('reload');
      } catch (err) {
        notificationService.showAxiosError(err);
      }
    }
  }

  async generateAdvancedInvoice() {
    const grid = this.$refs.grid as Datagrid;
    if (grid) {
      const selectedRows: IQuotation[] = (grid.$refs.quotationsTable as any).instance.getSelectedRowsData();
      const idList = selectedRows.map((o) => o.id);

      try {
        (this.$refs.InvoiceGenerateAdvanceDialog as InvoiceGenerateAdvanceDialog).show = true;
        (this.$refs.InvoiceGenerateAdvanceDialog as InvoiceGenerateAdvanceDialog).quotationIds = idList as string[];
      } catch (err) {
        notificationService.showAxiosError(err);
      }
    }
  }

  async generateInvoice() {
    const grid = this.$refs.grid as Datagrid;
    if (grid) {
      const selectedRows: IQuotation[] = (grid.$refs.quotationsTable as any).instance.getSelectedRowsData();
      const idList = selectedRows.map((o) => o.id!);
      try {
        const result = await new InvoicesClient(undefined, this.$axios).generateInvoiceFromQuotations(
          new GenerateInvoiceFromQuotationsCommand({
            sourceList: idList,
          })
        );
        notificationService.saved();
        this.$router.push({ path: `/invoices/${result}` });
      } catch (err) {
        notificationService.showAxiosError(err);
      }
    }
  }

  get worktypes() {
    const catalog = this.$store.getters['catalogs/list']('WorkTypes');
    const values = catalog ? catalog.values : [];

    return values;
  }

  get columns() {
    const self = this;

    return [
      {
        dataField: 'title',
        caption: this.$t('objects.quotations.Title'),
      },
      {
        dataField: 'documentNumber',
        caption: this.$t('objects.quotations.DocumentNumber'),
      },
      {
        dataField: 'internalContact',
        caption: this.$t('objects.quotations.InternalContact'),
      },
      {
        dataField: 'projectType',
        caption: this.$t('objects.quotations.ProjectType'),
      },
      {
        dataField: 'type',
        caption: 'Soort',
        lookup: {
          dataSource: [
            { value: QuotationType.Standard, text: 'Standaard' },
            { value: QuotationType.AdditionalWork, text: 'Meerwerk' },
            { value: QuotationType.FlatRate, text: 'Forfaitair' },
            { value: QuotationType.Raming, text: 'Raming' },
            { value: QuotationType.Execution, text: 'Uitvoeringsstaat' },
          ],
          displayExpr: 'text',
          valueExpr: 'value',
        },
      },
      {
        caption: 'Klant informatie',
        columns: [
          {
            dataField: 'customer.displayName',
            caption: this.$t('objects.quotations.fields.Customer'),
          },
          {
            dataField: 'customer.type',
            caption: 'soort klant',
            lookup: {
              dataSource: [
                { value: 'Company', text: 'Bedrijf' },
                { value: 'Contact', text: 'Particulier' },
                { value: 'Employee', text: 'Medewerker' },
                { value: 'Subcontractor', text: 'Onderaannemer' },
              ],
              displayExpr: 'text',
              valueExpr: 'value',
            },
          },
          {
            dataField: 'customerContact.displayName',
            caption: this.$t('objects.quotations.fields.CustomerContact'),
          },
        ],
      },
      {
        dataField: 'date',
        caption: this.$t('objects.quotations.Date'),
        dataType: 'date',
        format: 'dd/MM/yyyy',
      },
      {
        dataField: 'createDate',
        caption: this.$t('objects.quotations.CreateDate'),
        dataType: 'date',
        format: 'dd/MM/yyyy',
      },
      {
        dataField: 'status',
        caption: this.$t('objects.quotations.Status'),
        lookup: {
          dataSource: this.quotationStatusses,
          displayExpr: 'text',
          valueExpr: 'value',
        },
      },
      {
        dataField: 'workType',
        caption: this.$t('objects.quotations.fields.WorkType'),
        lookup: {
          dataSource: this.worktypes,
        },
      },

      {
        dataField: 'measurementName',
        caption: this.$t('objects.quotations.MeasuringName'),
      },
      {
        caption: this.$t('objects.quotations.Total'),
        format: {
          type: 'currency',
          precision: 2,
        },
        alignment: 'left',
        calculateCellValue(value: any) {
          if (value.discountLines == null || !value.discountLines.some((dl: any) => dl.isSelected)) {
            return value.total;
          }

          return value.totalWithDiscount;
        },
      },
      {
        dataField: 'margin',
        caption: this.$t('objects.quotations.Margin'),
        dataType: 'number',
        format: {
          type: 'currency',
          precision: 2,
        },
        alignment: 'left',
      },
      {
        type: 'buttons',
        buttons: [
          {
            hint: 'Duplicate',
            icon: 'fas fa-copy',
            visible(e: any) {
              return !e.row.isEditing && !e.row.data.isCompleted && !self.disabled;
            },
            onClick: this.duplicate,
          },
          {
            icon: 'far fa-comment',
            visible(e: any) {
              return e.row.data.internalNotes && e.row.data.internalNotes.replace(/(\r\n|\n|\r)/gm, '') != '';
            },
            onClick: this.lookupInternalNote,
          },
          'edit',
          'delete',
        ],
      },
    ];
  }

  get statusFilter() {
    const value = this.$route.query.status;

    let stringValue = '';
    if (value !== undefined && value !== null) {
      if (Array.isArray(value) && value.length > 0) {
        stringValue = value[0] !== null ? value[0] : '';
      } else {
        stringValue = value as string;
      }

      if (!isNaN(stringValue as any)) {
        return parseInt(stringValue, 10);
      }
    }

    return null;
  }

  get statusFilterName() {
    switch (this.statusFilter) {
      case 0:
        return 'Klad';
      case 1:
        return 'Open';
      case 2:
        return 'Verstuurd';
    }

    return '';
  }

  @Watch('statusFilter')
  onPropertyChanged(value: boolean, oldValue: boolean) {
    // Do stuff with the watcher here.
    this.SetStatusFilter();
  }
}
